/** @jsx jsx */
import {jsx, css} from '@emotion/core';

const server = 'https://infinite-dusk-89390.herokuapp.com';

const css_desc = css`
  display: block;
  position: fixed;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  background-color: white;
  padding: 10px;
  margin: auto;
  border-radius: 10px;
  margin-bottom: 2rem;
  width: 400px;
  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.5);
  cursor: pointer;

  .h {
    text-align: center;
  }

  .img {
    border: 2px solid black;
    border-radius: 10px;
    filter: drop-shadow(0 0 10px #888);
    height: 80px;
    width: 80px;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
    padding: 10px;
    display: block;
    margin: auto;
  }

  .p {
    text-align: center;
    margin: 10px;
  }

  .close {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    text-shadow: none;
    color: #bbb;
  }

  .close:hover {
    text-decoration: none;
    cursor: pointer;
    color: #000000;
  }

  .holder {
    position: relative;
    margin: auto;
    width: 100px;
    margin-left: auto;
  }
  #tier {
    display: block;
    position: absolute;
    bottom: -5px;
    right: 0px;
    padding: 3px;
    border: 1px solid black;
    border-radius: 5px;
    background: white;
  }
`;

export default ({
  callback,
  id,
  name,
  bag,
  soulbound,
  tier,
  slot,
  description,
}) => {
  const closeModal = () => callback(-1);
  return (
    <div css={css_desc} className="modal">
      <span className="close" onClick={closeModal}>
        &times;
      </span>
      <h4 className="h">{name}</h4>
      <div className="holder">
        <img className="img" src={`${server}/tiles/${id}`} alt={name} />
        {tier !== -1 && <div id="tier">T{tier}</div>}
      </div>

      <p className="p">
        {bag
          .split(' ')
          .map((s) => s[0].toUpperCase() + s.substr(1))
          .join(' ')}
        , {slot}
        {soulbound ? ', Soulbound' : ''}
      </p>
      {description.split('\\n').map((par, i) => {
        return (
          <p key={i} className="p">
            {par}
          </p>
        );
      })}
    </div>
  );
};
